import React from 'react';

import Container from '@common/Container';
import Section from '@common/Section';
import Button from '@common/Button';

const Default = ({ data }) => {
  return (
    <Section>
      <Container>
        <div className='d-flex justify-content-center'>
          <Button
            to={data.link}
            variant={data.variant}
            size={data.size}
            addClass={data.class}
            copy={data.copy}
            modal={data.modal}
          />
        </div>
      </Container>
    </Section>
  )
}

export default Default
